// usage:
// v-dropdown="{opened: isDropDownOpened}" (isDropDownOpened - reactive boolean)
// @dropdown:closed="isDropDownOpened = false" support window close - change the reactive var when closing. otherwise
// closeOnSelfClick : false - if true the dropdown will close when clicked inside
let getDropDownObject = ($dropdown, $target, options = {}, symbol) => {
  const positionType =
          utilities.hasProperty(options, "fixed") || options.fixed
            ? "fixed"
            : "absolute";
  let positionAndShowDropdown = async (
    $dropdown = $dropdown,
    $target = $target,
    options = options
  ) => {
    try {
      //sets new target if user passed targetElement
      if (options.targetElement) {
        const newTarget = document.querySelector(options.targetElement);
        if (newTarget) {
          $target = newTarget;
        } else {
          warn(
            "requested a drop down for element that doesnt exist, target element will remain sibling. target element that doesnt exist:",
            options.targetElement
          );
        }
      }

      // get references and calculate
      let defaultGap = config.style.dropdown.gap
        ? config.style.dropdown.gap
        : 10;
      let viewportOffset = $target.getBoundingClientRect();
      let targetTop = viewportOffset.top;
      let targetHeight = $target.offsetHeight;
      let targetWidth = $target.offsetWidth;
      let $targetParent = $target.parentElement;

      let targetParentHeight = $targetParent.offsetHeight;
      let totalHeight = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      );
      let targetSpaceFromBottom = totalHeight - targetTop - targetHeight;
      let targetSpaceFromTop = targetTop;
      let targetOffsetFromParentTop = $target.offsetTop;
      let targetOffsetFromParentBottom =
            targetParentHeight - targetOffsetFromParentTop;
      let gap = options.gap ? options.gap : defaultGap;
      // sets a width if user passed it, otherwise will be NaN
      const inputWidth = parseInt(options.width);

      let fixDropdownHorizontalOverflow = () => {
        if (inputWidth) {
          $dropdown.style.width = inputWidth + "px";
        }

        if (positionType == "absolute") {
          // detect right overflow and correct
          var dropdownWidth = $dropdown.offsetWidth;
          var distanceToRight =
                window.innerWidth - $targetParent.getBoundingClientRect().right;
          var distanceToLeft = $targetParent.offsetLeft;
          let overflowRight = dropdownWidth + gap - distanceToRight;
          let overflowLeft = dropdownWidth + gap - distanceToLeft;

          if (overflowRight > 0) {
            $dropdown.style.right = 0;
            $dropdown.style.left = "auto";
          }

          if (overflowLeft > 0) {
            $dropdown.style.right = "auto";
            $dropdown.style.left = 0;
          }
          //if position is fixed
        } else {
          //if user did not enter width, the width set will be of the target object
          if (!inputWidth) {
            $dropdown.style.width = targetWidth + "px";
          }

          const distanceFromRightToTargetCenter =
                  window.innerWidth -
                  (viewportOffset.left + viewportOffset.width / 2);
          //sets dropdown to be centered relatively to the target object center
          $dropdown.style.right = options.offsetX
            ? options.offsetX
            : distanceFromRightToTargetCenter -
            (inputWidth || targetWidth) / 2 -
            gap +
            "px";
          $dropdown.style.left = "auto";
        }
      };

      let placeDropdownOnBottom = () => {
        $dropdown.style.position = positionType;
        $dropdown.style.bottom = "auto";
        if (positionType == "absolute") {
          $dropdown.style.top =
            +targetOffsetFromParentTop + targetHeight + gap + "px";
        } else {
          $dropdown.style.top = options.offsetY
            ? options.offsetY
            : targetHeight + targetTop + gap + "px";
        }
        $dropdown.style["z-index"] = $dropdown.style["z-index"] || 2000;

        // check space from inline end
        // compute our size
        // compute position of parent from right
      };

      let placeDropdownOnTop = () => {
        $dropdown.style.position = positionType;
        $dropdown.style.top = "auto";
        if (positionType == "absolute") {
          $dropdown.style.bottom = +targetOffsetFromParentBottom + gap + "px";
        } else {
          $dropdown.style.bottom = options.offsetY
            ? options.offsetY
            : targetHeight + targetSpaceFromBottom + gap + "px";
        }
        $dropdown.style["z-index"] = $dropdown.style["z-index"] || 2000;
      };

      // position dropdown
      targetSpaceFromBottom >= targetSpaceFromTop
        ? placeDropdownOnBottom()
        : placeDropdownOnTop();

      fixDropdownHorizontalOverflow();

      $dropdown.dispatchEvent(new Event("dropdown:opening"));

      try {
        // without a delay there is an issue with window click event close mechanism, using nextTick() doesn't work
        $dropdown.style.display = "block";
        $dropdown[dropdownSymbol].isOpened = true;
        $dropdown.dispatchEvent(new Event("dropdown:opened"));
      } catch (e) {

      }

    } catch (e) {

    }
  };

  let hideDropdown = async () => {
    try {
      if (!$dropdown[dropdownSymbol].isOpened) {
        return;
      }
      $dropdown.style.display = "none";
      $dropdown.dispatchEvent(new Event("dropdown:closing"));
      try {
        // without a delay there is an issue with window click event close mechanism, using nextTick() doesn't work
        $dropdown[dropdownSymbol].isOpened = false;
        $dropdown.dispatchEvent(new Event("dropdown:closed"));
      } catch (e) {}
    } catch (e) {}
  };
  let makeElementDropdownable = () => {
    try {
      // parent must be positioned
      if ($dropdown.parentElement.style.display === "static") {
        $dropdown.parentElement.style.display = "relative";
      }

      // element initial visibility and position need to be adjusted
      $dropdown.style.display = "none";
      $dropdown.style.position = positionType;

      // apply animations by condig
      let desiredAnimationClass = config.style.dropdown.animationClass;

      if (
        !options.hasOwnProperty("applyAnimations") ||
        options.applyAnimations
      ) {
        if (typeof desiredAnimationClass === "string") {
          desiredAnimationClass = desiredAnimationClass.split(" ");
        }

        if (Array.isArray(desiredAnimationClass)) {
          desiredAnimationClass.forEach((className) => {
            $dropdown.classList.add(className);
          });
        }
      }

      $dropdown[symbol].isOpened = false;
    } catch (e) {}
  };

  let result = {
    isOpened: false,
    positionAndShowDropdown,
    hideDropdown,
    makeElementDropdownable,
  };

  $dropdown[symbol] = result;

  return result;
};

let dropdownSymbol = Symbol("saffron-drop-down");

export default {
  updated(el, { value: directiveData }) {
    if (utilities.isSSR()) {
      return;
    }

    if (directiveData.opened) {
      const sibling = el.previousSibling ? el.previousSibling : el.nextSibling;
      if (!sibling) {
        utilities.debug(
          "dropdown directive: sibling not found. There must be a sibling next to the element with v-dropdown. This is used to place the dropdown. Expect problems.",
          2
        );
      }

      if (el[dropdownSymbol]) {
        el[dropdownSymbol].positionAndShowDropdown(el, sibling, directiveData);
      }

      return;
    }

    // directiveData.opened is false
    if (el[dropdownSymbol]) {

      el[dropdownSymbol].hideDropdown(el);
    }
  },

  mounted(el, { value: directiveData }) {
    if (utilities.isSSR()) {
      return;
    }

    // save reference to element
    el[dropdownSymbol] = getDropDownObject(
      el,
      el.previousSibling,
      directiveData,
      dropdownSymbol
    );

    // init the dropdown
    el[dropdownSymbol].makeElementDropdownable(el);

    // listen to window click event to close it
    window.addEventListener("click", (e) => {
      const isInside = el.contains(e.target);

      if (isInside && !directiveData?.closeOnSelfClick) {
        return;
      }
      if (
        directiveData.exceptId &&
        e.target.closest("#" + directiveData.exceptId)
      ) {
        return;
      }

      if ( ! el[dropdownSymbol].isOpened) {
        el[dropdownSymbol].hideDropdown();
      }
    });
  },

  beforeUnmount(el) {
    if (utilities.isSSR()) {
      return;
    }

    try {
      if (el[dropdownSymbol]) {
        el[dropdownSymbol].hideDropdown(el);
      }
    } catch (e) {
      console.log(e);
    }

    try {
      if (el[dropdownSymbol]) {
        window.removeEventListener("click", el[dropdownSymbol].hideDropdown);
      }
    } catch (e) {
      //
    }
  },
};
